import httpClient from '../utils/httpClient';

const API = '/dashboard';

export const getGeneralStats = async () => httpClient.get(`${API}/stats`);
export const getFinancialStats = async () => httpClient.get(`${API}/financial`);
export const getAcademicStats = async () => httpClient.get(`${API}/academic`);
export const getRecentActivity = async (limit = 10) => httpClient.get(`${API}/activity?limit=${limit}`);
export const getDelinquencyReport = async () => httpClient.get(`${API}/delinquency`);
export const getEnrollmentByStudy = async () => httpClient.get(`${API}/enrollment`);
